export enum AuctionLaneCode {
    NEXT_AUCTION = 'NEXT_AUCTION',
    TODAYS_AUCTION = 'TODAYS_AUCTION',
    CURRENT_AUCTION = 'CURRENT_AUCTION',
    NEXT_PM_AUCTION = 'NEXT_PM_AUCTION',
    NEXT_AM_AUCTION = 'NEXT_AM_AUCTION'
}
